export default "__VITE_ASSET__DzYX_Nxc__"